// src/context/MachineContext.js
import React, { createContext, useContext, useState } from "react";

const MachineContext = createContext();

export const MachineProvider = ({ children }) => {
  const [selectedMachineId, setSelectedMachineId] = useState(null);

  return (
    <MachineContext.Provider value={{ selectedMachineId, setSelectedMachineId }}>
      {children}
    </MachineContext.Provider>
  );
};

export const useMachine = () => useContext(MachineContext);
